// extracted by mini-css-extract-plugin
export default {"page":"settings_page__QxTXA","para":"settings_para__s-xUG","tabs":"settings_tabs__cJoH+"};